type PluralForms = [one: string, few: string, many: string];

/**
 * Русское склонение по числу: 1 балл, 2 балла, 5 баллов.
 * Дробные числа → форма few (1.5 балла).
 */
export const pluralize = (count: number, forms: PluralForms): string => {
  const n = Math.abs(count);

  if (!Number.isInteger(n)) {
    return forms[1];
  }

  const mod10 = n % 10;
  const mod100 = n % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return forms[0];
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return forms[1];
  }

  return forms[2];
};
